import { render, staticRenderFns } from "./SpaceyEmailsItem.vue?vue&type=template&id=3598c110&scoped=true"
import script from "./SpaceyEmailsItem.vue?vue&type=script&lang=js"
export * from "./SpaceyEmailsItem.vue?vue&type=script&lang=js"
import style0 from "./SpaceyEmailsItem.vue?vue&type=style&index=0&id=3598c110&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598c110",
  null
  
)

export default component.exports